<template>
  <div v-if="modelValue" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
    aria-modal="true" @click.self="closePopup">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="closePopup"></div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
        class="inline-block align-bottom bg-white rounded-[20px] text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full max-w-6xl">

        <div
          class="relative h-[700px] md:p-16 p-8 border-2 border-white w-full max-w-6xl z-50 max-h-full bg-primary rounded-[20px] bg-no-repeat bg-contain bg-bottom md:bg-right "
          :class="companyId == 1 ? 'bg-login-bg' : companyId == 3 ? 'bg-login-bg-hop' : 'bg-login-bg-easyJet'">
          <div class="flex justify-between items-center">
            <div></div>
            <button data-modal-target="login-modal" data-modal-toggle="login-modal" @click="closePopup">
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.485 8.42276C14.8761 6.02716 17.2249 3.67388 19.5738 1.32061C20.0976 0.787312 20.6215 0.270946 21.3903 0.0847157C22.6577 -0.203095 23.9419 0.313271 24.5925 1.40526C25.26 2.53111 25.0994 3.96169 24.17 4.90978C22.362 6.74669 20.5285 8.56666 18.712 10.3866C18.0192 11.0808 17.3179 11.7834 16.5997 12.4944C17.8079 13.6965 18.9992 14.89 20.1906 16.0836C21.5086 17.3957 22.8266 18.7078 24.1278 20.0368C25.2177 21.1541 25.2853 22.8048 24.3306 23.9561C23.2406 25.2681 21.2889 25.3613 20.03 24.1338C18.6613 22.7964 17.3179 21.425 15.966 20.0706C14.8254 18.9278 13.6764 17.7766 12.5104 16.6084C12.4006 16.71 12.3076 16.7947 12.2062 16.8878C9.8067 19.2918 7.41563 21.6959 5.00766 24.0915C3.50373 25.5898 1.12111 25.175 0.259308 23.2873C-0.247633 22.1869 -0.00261155 20.9256 0.918332 19.986C2.1012 18.7839 3.30096 17.5904 4.50072 16.3968C5.79342 15.1017 7.08612 13.8065 8.40417 12.4944C7.17061 11.2585 5.9455 10.0396 4.72039 8.81215C3.46149 7.5424 2.18569 6.27264 0.909883 4.99443C0.0903277 4.17332 -0.163143 3.18291 0.141022 2.08246C0.453636 0.990473 1.2056 0.296341 2.31242 0.0677857C3.377 -0.152305 4.29794 0.169366 5.07525 0.948148C7.41563 3.30989 9.77291 5.6547 12.1133 8.00797C12.24 8.13495 12.3414 8.27039 12.485 8.42276Z"
                  fill="white" />
              </svg>
            </button>
          </div>
          <div class="md:w-1/2 w-full">
            <div v-if="!forgotPassword">
              <h6 class="text-white text-2xl font-semibold mb-6">Accès adhérent</h6>
              <div v-if="message" class="py-2 bg-white px-4 rounded-[4px] mb-4">
                <p class="text-red-500 text-sm">
                  {{ message }}
                </p>
              </div>
              <form @submit.prevent="validateAndSubmit">
                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px] mb-4">
                  <label for="mail-address" class="text-sm font-semibold text-white px-2 bg-primary">Identifiant</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.5941 9.69609C13.5673 9.69609 16 12.1128 16 15.0663V19H0V15.0663C0 12.1128 2.43267 9.69609 5.40592 9.69609H10.5941ZM7.99628 0C10.3731 0 12.2937 1.91794 12.2937 4.26945C12.2937 6.62314 10.3731 8.53239 7.99628 8.53565C5.6238 8.53239 3.70656 6.62314 3.70656 4.26945C3.70656 1.91794 5.6238 0.0021733 7.99628 0Z"
                        fill="white" />
                    </svg>
                    <div class="flex-1 relative">
                      <input type="text" id="mail-address" v-model="email" placeholder="Adresse mail"
                        class="bg-transparent w-full focus:outline-none autofill:bg-primary border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': errors.email }">
                      <div v-if="errors.email" class="absolute right-0 top-0">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8.5" cy="8.5" r="8.5" fill="#EE223A" />
                          <path
                            d="M12.6433 11.1942C12.7816 11.3455 12.8566 11.545 12.8527 11.7509C12.8487 11.9569 12.766 12.1533 12.622 12.299C12.478 12.4447 12.2837 12.5284 12.08 12.5325C11.8762 12.5367 11.6788 12.461 11.5291 12.3212L8.52123 9.28076L5.51338 12.3212C5.44128 12.4001 5.35418 12.4634 5.2573 12.5073C5.16041 12.5513 5.05574 12.575 4.94956 12.5771C4.84338 12.5792 4.73787 12.5596 4.63937 12.5195C4.54087 12.4793 4.4514 12.4195 4.37633 12.3436C4.30126 12.2676 4.24213 12.1772 4.20249 12.0776C4.16286 11.978 4.14353 11.8713 4.14567 11.764C4.1478 11.6566 4.17136 11.5508 4.21493 11.4529C4.2585 11.355 4.32118 11.267 4.39921 11.1942L7.40707 8.15374L4.39921 5.11482C4.32118 5.042 4.2585 4.954 4.21493 4.85609C4.17136 4.75819 4.1478 4.6524 4.14567 4.54507C4.14353 4.43773 4.16286 4.33107 4.20249 4.23147C4.24213 4.13188 4.30126 4.0414 4.37633 3.96546C4.4514 3.88952 4.54087 3.82969 4.63937 3.78956C4.73787 3.74943 4.84338 3.72981 4.94956 3.7319C5.05574 3.73399 5.16041 3.75773 5.2573 3.8017C5.35418 3.84568 5.44128 3.90898 5.51338 3.9878L8.52123 7.0275L11.5291 3.98703C11.6788 3.8473 11.8762 3.77157 12.08 3.77572C12.2837 3.77986 12.478 3.86356 12.622 4.00927C12.766 4.15497 12.8487 4.35138 12.8527 4.55733C12.8566 4.76328 12.7816 4.96279 12.6433 5.11405L9.6354 8.15374L12.6433 11.1942Z"
                            fill="white" />
                        </svg>
                      </div>
                      <div v-else-if="emailValid" class="absolute right-0 top-0">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="8.5" cy="8.5" r="8.5" fill="#4ADE80" />
                          <path
                            d="M7.61352 9.72219C7.91375 9.43336 8.19985 9.1511 8.49301 8.87868C9.69745 7.7562 10.8984 6.63043 12.1169 5.51778C12.3183 5.33399 12.569 5.17973 12.8233 5.07142C13.2013 4.90731 13.5545 5.03531 13.7876 5.36024C14.1126 5.81318 14.0631 6.31534 13.6498 6.69935C11.9262 8.30431 10.199 9.90927 8.46828 11.511C8.32347 11.6455 8.16099 11.767 7.99145 11.872C7.72655 12.0361 7.43692 12.0525 7.18614 11.8621C6.84353 11.5996 6.51151 11.3173 6.19362 11.0285C5.54725 10.441 4.92561 9.82394 4.26511 9.24956C3.8024 8.84258 3.99314 7.96297 4.46997 7.70696C4.74194 7.55927 5.02097 7.58224 5.27881 7.71353C5.49074 7.82512 5.6956 7.96297 5.8722 8.11723C6.38789 8.58001 6.88944 9.05592 7.39806 9.52855C7.45811 9.58762 7.52169 9.64014 7.61352 9.72219Z"
                            fill="white" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <p v-if="errors.email" class="text-red-500 bg-white px-2 py-1 text-xs mt-1">{{ errors.email }}</p>
                </div>

                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px]">
                  <label for="password" class="text-sm font-semibold text-white px-2 bg-primary">Mot de passe</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 9.71648V20.7372C15.9992 21.0719 15.8701 21.3926 15.641 21.6292C15.4119 21.8658 15.1013 21.9992 14.7773 22H1.22269C0.898666 21.9992 0.588142 21.8658 0.359019 21.6292C0.129896 21.3926 0.000815169 21.0719 0 20.7372V9.71648C0.000815169 9.38183 0.129896 9.06112 0.359019 8.82448C0.588142 8.58784 0.898666 8.45453 1.22269 8.45369H2.54419V5.63473C2.54419 4.89477 2.68531 4.16205 2.95949 3.47841C3.23367 2.79478 3.63554 2.17361 4.14216 1.65037C4.64878 1.12714 5.25022 0.71209 5.91215 0.428918C6.57408 0.145747 7.28353 0 8 0C8.71647 0 9.42592 0.145747 10.0878 0.428918C10.7498 0.71209 11.3512 1.12714 11.8578 1.65037C12.3645 2.17361 12.7663 2.79478 13.0405 3.47841C13.3147 4.16205 13.4558 4.89477 13.4558 5.63473V8.45369H14.7773C15.1013 8.45453 15.4119 8.58784 15.641 8.82448C15.8701 9.06112 15.9992 9.38183 16 9.71648ZM11.7453 5.63473C11.7453 4.60885 11.3507 3.62498 10.6483 2.89957C9.94593 2.17416 8.99331 1.76663 8 1.76663C7.00669 1.76663 6.05407 2.17416 5.35169 2.89957C4.64932 3.62498 4.25473 4.60885 4.25473 5.63473V8.45369H11.7453V5.63473ZM9.71054 13.7711C9.71054 13.455 9.62841 13.1446 9.4727 12.8724C9.31699 12.6003 9.09341 12.3762 8.82529 12.2237C8.55717 12.0712 8.25433 11.9957 7.94836 12.0053C7.6424 12.0148 7.34451 12.109 7.0858 12.2779C6.82708 12.4469 6.617 12.6845 6.47748 12.9659C6.33796 13.2473 6.2741 13.5622 6.29258 13.8777C6.31106 14.1933 6.41119 14.498 6.58253 14.76C6.75387 15.0219 6.99014 15.2316 7.26669 15.3672V18.3153C7.26669 18.5161 7.34395 18.7088 7.48147 18.8508C7.619 18.9928 7.80551 19.0726 8 19.0726C8.19449 19.0726 8.38101 18.9928 8.51853 18.8508C8.65605 18.7088 8.73331 18.5161 8.73331 18.3153V15.3672C9.02571 15.2239 9.27274 14.9978 9.44572 14.7153C9.61871 14.4328 9.71053 14.1054 9.71054 13.7711Z"
                        fill="white" />
                    </svg>

                    <div class="flex-1 relative">
                      <input :type="showPassword ? 'text' : 'password'" id="password" v-model="password" placeholder="●●●●●●●●●●●●●●"
                        class="bg-transparent w-full focus:outline-none autofill:bg-primary border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': errors.password }">
                      <div class="absolute right-0 -top-1">
                        <svg v-if="!showPassword" @click="showPassword = !showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.5" class="size-6 text-white" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/></svg>
                        <svg v-else @click="showPassword = !showPassword" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.5" class="size-6 text-white" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12c1.292 4.338 5.31 7.5 10.066 7.5.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"/></svg>
                      </div>
                    </div>
                  </div>
                  <p v-if="errors.password" class="text-red-500 text-xs bg-white px-2 py-1 mt-1">{{ errors.password }}
                  </p>
                </div>

                <div class="flex items-center justify-between mt-4">
                  <div class="flex items-center space-x-3">
                    <label class="relative inline-flex items-center cursor-pointer">
                      <input type="checkbox" v-model="remember" id="remember_me" class="sr-only peer">
                      <div
                        class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary border-white border rounded-full peer peer-checked:bg-primary transition-all">
                      </div>
                      <div
                        class="absolute left-1 top-1 bg-white w-4 h-4 rounded-full shadow peer-checked:translate-x-5 transition-all">
                      </div>
                    </label>
                    <label for="remember_me" class="text-xs text-white">Mémoriser</label>
                  </div>
                  <button type="button" class="text-xs text-white font-semibold" @click="forgotPassword = true">Mot de
                    passe oublié ?</button>
                </div>
                <div class="my-4">
                  <button type="submit"
                    class="w-full py-2 bg-white shadow-md text-md text-primary font-bold rounded-[10px]"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? 'Connexion en cours...' : 'Connexion' }}
                  </button>
                </div>
              </form>
              <div class="my-4">
                <RouterLink :to="{ name: 'adhesion' }">
                  <button @click="closeModal()" class="w-full py-2 bg-white shadow-md text-md text-primary font-semibold rounded-[10px]">
                    Pas de compte ? <b> Adhérer à l'UNAC</b>
                  </button>
                </RouterLink>
              </div>
            </div>

            <div v-if="forgotPassword">
              <h6 class="text-white text-2xl font-semibold mb-6">Accès adhérent</h6>
              <p class="text-white mb-4">Réinitialisez votre mot de passe</p>

              <!-- Step 1: Email Input -->
              <div v-if="resetStep === 1">
                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px] mb-4">
                  <label for="reset-email" class="text-sm font-semibold text-white px-2 bg-primary">Identifiant</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.5941 9.69609C13.5673 9.69609 16 12.1128 16 15.0663V19H0V15.0663C0 12.1128 2.43267 9.69609 5.40592 9.69609H10.5941ZM7.99628 0C10.3731 0 12.2937 1.91794 12.2937 4.26945C12.2937 6.62314 10.3731 8.53239 7.99628 8.53565C5.6238 8.53239 3.70656 6.62314 3.70656 4.26945C3.70656 1.91794 5.6238 0.0021733 7.99628 0Z"
                        fill="white" />
                    </svg>
                    <div class="flex-1 relative">
                      <input type="email" id="reset-email" v-model="resetEmail" placeholder="Adresse mail"
                        class="bg-transparent w-full focus:outline-none border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': resetErrors.email }">
                    </div>
                  </div>
                  <p v-if="resetErrors.email" class="text-red-500 text-xs bg-white px-2 py-1  mt-1">{{ resetErrors.email
                    }}</p>
                </div>
                <div class="text-white mb-4">
                  <p class="mb-2">
                    Vous recevrez un code de vérification à l'adresse mail renseignée lors de votre adhésion.
                  </p>
                </div>
                <div class="my-4">
                  <button @click="sendVerificationCode"
                    class="w-full py-2 bg-white shadow-md text-md text-primary font-bold rounded-[10px]"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? 'Envoi en cours...' : 'Envoyer le code' }}
                  </button>
                </div>
              </div>

              <!-- Step 2: Code Verification -->
              <div v-if="resetStep === 2">
                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px] mb-4">
                  <label for="verification-code" class="text-sm font-semibold text-white px-2 bg-primary">Code de
                    vérification</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.5941 9.69609C13.5673 9.69609 16 12.1128 16 15.0663V19H0V15.0663C0 12.1128 2.43267 9.69609 5.40592 9.69609H10.5941ZM7.99628 0C10.3731 0 12.2937 1.91794 12.2937 4.26945C12.2937 6.62314 10.3731 8.53239 7.99628 8.53565C5.6238 8.53239 3.70656 6.62314 3.70656 4.26945C3.70656 1.91794 5.6238 0.0021733 7.99628 0Z"
                        fill="white" />
                    </svg>
                    <div class="flex-1 relative">
                      <input type="text" id="verification-code" v-model="verificationCode"
                        placeholder="Entrez le code reçu"
                        class="bg-transparent w-full focus:outline-none border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': resetErrors.code }">
                    </div>
                  </div>
                  <p v-if="resetErrors.code" class="text-red-500 text-xs bg-white px-2 py-1  mt-1">{{ resetErrors.code
                    }}</p>
                </div>
                <div class="my-4">
                  <button @click="verifyCode"
                    class="w-full py-2 bg-white shadow-md text-md text-primary font-bold rounded-[10px]"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? 'Vérification...' : 'Vérifier le code' }}
                  </button>
                </div>
                <div class="text-center">
                  <button @click="resendCode"
                    class="text-xs text-white font-semibold hover:text-white/80 transition-colors duration-200"
                    :disabled="isResending">
                    {{ isResending ? 'Envoi en cours...' : 'Renvoyer le code' }}
                  </button>
                </div>
              </div>

              <!-- Step 3: New Password -->
              <div v-if="resetStep === 3">
                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px] mb-4">
                  <label for="new-password" class="text-sm font-semibold text-white px-2 bg-primary">Nouveau mot de
                    passe</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 9.71648V20.7372C15.9992 21.0719 15.8701 21.3926 15.641 21.6292C15.4119 21.8658 15.1013 21.9992 14.7773 22H1.22269C0.898666 21.9992 0.588142 21.8658 0.359019 21.6292C0.129896 21.3926 0.000815169 21.0719 0 20.7372V9.71648C0.000815169 9.38183 0.129896 9.06112 0.359019 8.82448C0.588142 8.58784 0.898666 8.45453 1.22269 8.45369H2.54419V5.63473C2.54419 4.89477 2.68531 4.16205 2.95949 3.47841C3.23367 2.79478 3.63554 2.17361 4.14216 1.65037C4.64878 1.12714 5.25022 0.71209 5.91215 0.428918C6.57408 0.145747 7.28353 0 8 0C8.71647 0 9.42592 0.145747 10.0878 0.428918C10.7498 0.71209 11.3512 1.12714 11.8578 1.65037C12.3645 2.17361 12.7663 2.79478 13.0405 3.47841C13.3147 4.16205 13.4558 4.89477 13.4558 5.63473V8.45369H14.7773C15.1013 8.45453 15.4119 8.58784 15.641 8.82448C15.8701 9.06112 15.9992 9.38183 16 9.71648ZM11.7453 5.63473C11.7453 4.60885 11.3507 3.62498 10.6483 2.89957C9.94593 2.17416 8.99331 1.76663 8 1.76663C7.00669 1.76663 6.05407 2.17416 5.35169 2.89957C4.64932 3.62498 4.25473 4.60885 4.25473 5.63473V8.45369H11.7453V5.63473ZM9.71054 13.7711C9.71054 13.455 9.62841 13.1446 9.4727 12.8724C9.31699 12.6003 9.09341 12.3762 8.82529 12.2237C8.55717 12.0712 8.25433 11.9957 7.94836 12.0053C7.6424 12.0148 7.34451 12.109 7.0858 12.2779C6.82708 12.4469 6.617 12.6845 6.47748 12.9659C6.33796 13.2473 6.2741 13.5622 6.29258 13.8777C6.31106 14.1933 6.41119 14.498 6.58253 14.76C6.75387 15.0219 6.99014 15.2316 7.26669 15.3672V18.3153C7.26669 18.5161 7.34395 18.7088 7.48147 18.8508C7.619 18.9928 7.80551 19.0726 8 19.0726C8.19449 19.0726 8.38101 18.9928 8.51853 18.8508C8.65605 18.7088 8.73331 18.5161 8.73331 18.3153V15.3672C9.02571 15.2239 9.27274 14.9978 9.44572 14.7153C9.61871 14.4328 9.71053 14.1054 9.71054 13.7711Z"
                        fill="white" />
                    </svg>
                    <div class="flex-1 relative">
                      <input type="password" id="new-password" v-model="newPassword" placeholder="Nouveau mot de passe"
                        class="bg-transparent w-full focus:outline-none border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': resetErrors.password }">
                    </div>
                  </div>
                  <p v-if="resetErrors.password" class="text-red-500 bg-white px-2 py-1  text-xs mt-1">{{
                    resetErrors.password }}</p>
                </div>

                <div class="border-2 border-white bg-primary px-4 py-2 rounded-[15px] mb-4">
                  <label for="confirm-password" class="text-sm font-semibold text-white px-2 bg-primary">Confirmer le
                    mot de passe</label>
                  <div class="flex space-x-2 items-center mt-2">
                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16 9.71648V20.7372C15.9992 21.0719 15.8701 21.3926 15.641 21.6292C15.4119 21.8658 15.1013 21.9992 14.7773 22H1.22269C0.898666 21.9992 0.588142 21.8658 0.359019 21.6292C0.129896 21.3926 0.000815169 21.0719 0 20.7372V9.71648C0.000815169 9.38183 0.129896 9.06112 0.359019 8.82448C0.588142 8.58784 0.898666 8.45453 1.22269 8.45369H2.54419V5.63473C2.54419 4.89477 2.68531 4.16205 2.95949 3.47841C3.23367 2.79478 3.63554 2.17361 4.14216 1.65037C4.64878 1.12714 5.25022 0.71209 5.91215 0.428918C6.57408 0.145747 7.28353 0 8 0C8.71647 0 9.42592 0.145747 10.0878 0.428918C10.7498 0.71209 11.3512 1.12714 11.8578 1.65037C12.3645 2.17361 12.7663 2.79478 13.0405 3.47841C13.3147 4.16205 13.4558 4.89477 13.4558 5.63473V8.45369H14.7773C15.1013 8.45453 15.4119 8.58784 15.641 8.82448C15.8701 9.06112 15.9992 9.38183 16 9.71648ZM11.7453 5.63473C11.7453 4.60885 11.3507 3.62498 10.6483 2.89957C9.94593 2.17416 8.99331 1.76663 8 1.76663C7.00669 1.76663 6.05407 2.17416 5.35169 2.89957C4.64932 3.62498 4.25473 4.60885 4.25473 5.63473V8.45369H11.7453V5.63473ZM9.71054 13.7711C9.71054 13.455 9.62841 13.1446 9.4727 12.8724C9.31699 12.6003 9.09341 12.3762 8.82529 12.2237C8.55717 12.0712 8.25433 11.9957 7.94836 12.0053C7.6424 12.0148 7.34451 12.109 7.0858 12.2779C6.82708 12.4469 6.617 12.6845 6.47748 12.9659C6.33796 13.2473 6.2741 13.5622 6.29258 13.8777C6.31106 14.1933 6.41119 14.498 6.58253 14.76C6.75387 15.0219 6.99014 15.2316 7.26669 15.3672V18.3153C7.26669 18.5161 7.34395 18.7088 7.48147 18.8508C7.619 18.9928 7.80551 19.0726 8 19.0726C8.19449 19.0726 8.38101 18.9928 8.51853 18.8508C8.65605 18.7088 8.73331 18.5161 8.73331 18.3153V15.3672C9.02571 15.2239 9.27274 14.9978 9.44572 14.7153C9.61871 14.4328 9.71053 14.1054 9.71054 13.7711Z"
                        fill="white" />
                    </svg>
                    <div class="flex-1 relative">
                      <input type="password" id="confirm-password" v-model="confirmPassword"
                        placeholder="Confirmer le mot de passe"
                        class="bg-transparent w-full focus:outline-none border-b border-white/50 placeholder:text-white/50 text-white"
                        :class="{ 'border-red-500': resetErrors.confirmPassword }">
                    </div>
                  </div>
                  <p v-if="resetErrors.confirmPassword" class="text-red-500 bg-white px-2 py-1  text-xs mt-1">{{
                    resetErrors.confirmPassword }}</p>
                </div>

                <div class="my-4">
                  <button @click="resetPassword"
                    class="w-full py-2 bg-white shadow-md text-md text-primary font-bold rounded-[10px]"
                    :disabled="isSubmitting">
                    {{ isSubmitting ? 'Réinitialisation...' : 'Réinitialiser le mot de passe' }}
                  </button>
                </div>
              </div>

              <div class="text-center">
                <button class="text-xs text-white font-semibold underline" @click="resetForgotPassword">
                  Je me souviens de mon mot de passe
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { ref, computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
});

const emit = defineEmits(['update:modelValue']);
const authStore = useAuthStore();

const email = ref('');
const password = ref('');
const remember = ref(false);
const forgotPassword = ref(false);
const isSubmitting = ref(false);
const message = ref('');
const showPassword = ref(false);

const companyId = computed(() => {
  const company = JSON.parse(localStorage.getItem('selectedCompany'));
  return company?.id || 1;
})

const errors = ref({
  email: '',
  password: ''
});

const emailValid = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email.value && emailRegex.test(email.value);
});

const passwordValid = computed(() => {
  return password.value && password.value.length >= 6;
});

const validateForm = () => {
  errors.value = {
    email: '',
    password: ''
  };

  let isValid = true;

  if (!email.value) {
    errors.value.email = 'Email est requis';
    isValid = false;
  } else if (!emailValid.value) {
    errors.value.email = 'Veuillez entrer une adresse email valide';
    isValid = false;
  }

  if (!password.value) {
    errors.value.password = 'Mot de passe est requis';
    isValid = false;
  } else if (password.value.length < 6) {
    errors.value.password = 'Le mot de passe doit contenir au moins 6 caractères';
    isValid = false;
  }

  return isValid;
};

const validateAndSubmit = async () => {
  if (validateForm()) {
    isSubmitting.value = true;
    try {
      await handleLogin();
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      isSubmitting.value = false;
    }
  }
};

const handleLogin = async () => {
  message.value = '';
  const deviceName = navigator.userAgent;
  const devicePlatform = navigator.userAgentData?.platform || 'Unknown';
  const deviceType = 'web';
  try {
    const response = await authStore.login({
      email: email.value,
      password: password.value,
      remember: remember.value,
      device_infos: {
        device_type: deviceType,
        device_name: deviceName,
        device_platform: devicePlatform
      }
    });

    if (response?.success === false) {
      message.value = response?.message;
      return;
    }

    message.value = "Connexion réussie";
    email.value = '';
    password.value = '';
    remember.value = false;
    errors.value = {
      email: '',
      password: ''
    };

    closePopup();
    message.value = "";

  } catch (error) {
    console.error('Login failed:', error);
    message.value = error.response?.data?.message || "Une erreur s'est produite";
  }
};

const closePopup = () => {
  emit('update:modelValue', false);
};

const resetStep = ref(1)
const resetEmail = ref('')
const verificationCode = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const resetToken = ref('')
const resetErrors = ref({
  email: '',
  code: '',
  password: '',
  confirmPassword: ''
})

const resetForgotPassword = () => {
  forgotPassword.value = false
  resetStep.value = 1
  resetEmail.value = ''
  verificationCode.value = ''
  newPassword.value = ''
  confirmPassword.value = ''
  resetToken.value = ''
  resetErrors.value = {
    email: '',
    code: '',
    password: '',
    confirmPassword: ''
  }
}

const validateResetEmail = () => {
  resetErrors.value.email = ''
  if (!resetEmail.value) {
    resetErrors.value.email = 'Email est requis'
    return false
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(resetEmail.value)) {
    resetErrors.value.email = 'Veuillez entrer une adresse email valide'
    return false
  }
  return true
}

const validateVerificationCode = () => {
  resetErrors.value.code = ''
  if (!verificationCode.value) {
    resetErrors.value.code = 'Le code de vérification est requis'
    return false
  }
  return true
}

const validateNewPassword = () => {
  resetErrors.value.password = ''
  resetErrors.value.confirmPassword = ''

  if (!newPassword.value) {
    resetErrors.value.password = 'Le mot de passe est requis'
    return false
  }
  if (newPassword.value.length < 6) {
    resetErrors.value.password = 'Le mot de passe doit contenir au moins 6 caractères'
    return false
  }
  if (newPassword.value !== confirmPassword.value) {
    resetErrors.value.confirmPassword = 'Les mots de passe ne correspondent pas'
    return false
  }
  return true
}

const sendVerificationCode = async () => {
  if (!validateResetEmail()) return

  isSubmitting.value = true
  try {
    const response = await axios.post('forgot-password', {
      email: resetEmail.value
    })

    if (response.data.success) {
      resetStep.value = 2
    } else {
      resetErrors.value.email = response.data.message || 'Une erreur est survenue'
    }
  } catch (error) {
    resetErrors.value.email = error.response?.data?.message || 'Une erreur est survenue'
  } finally {
    isSubmitting.value = false
  }
}

const verifyCode = async () => {
  if (!validateVerificationCode()) return

  isSubmitting.value = true
  try {
    const response = await axios.post('code-verefication', {
      email: resetEmail.value,
      code: verificationCode.value
    })

    if (response.data.success) {
      resetToken.value = response.data.token
      resetStep.value = 3
    } else {
      resetErrors.value.code = response.data.message || 'Code invalide'
    }
  } catch (error) {
    resetErrors.value.code = error.response?.data?.message || 'Une erreur est survenue'
  } finally {
    isSubmitting.value = false
  }
}

const resetPassword = async () => {
  if (!validateNewPassword()) return

  isSubmitting.value = true
  try {
    const response = await axios.post('password/reset', {
      email: resetEmail.value,
      token: resetToken.value,
      password: newPassword.value,
      password_confirmation: confirmPassword.value
    })

    if (response.data.success) {
      message.value = 'Mot de passe réinitialisé avec succès'
      resetForgotPassword()
    } else {
      resetErrors.value.password = response.data.message || 'Une erreur est survenue'
    }
  } catch (error) {
    resetErrors.value.password = error.response?.data?.message || 'Une erreur est survenue'
  } finally {
    isSubmitting.value = false
  }
}

const isResending = ref(false)

const resendCode = async () => {
  if (!validateResetEmail()) return

  isResending.value = true
  try {
    const response = await axios.post('forgot-password', {
      email: resetEmail.value
    })

    if (response.data.success) {
      message.value = 'Un nouveau code a été envoyé à votre adresse email'
    } else {
      resetErrors.value.code = response.data.message || 'Une erreur est survenue'
    }
  } catch (error) {
    resetErrors.value.code = error.response?.data?.message || 'Une erreur est survenue'
  } finally {
    isResending.value = false
  }
}

const closeModal = () => {
  emit('update:modelValue', false)
}
</script>

<style scoped>
/* Override autofill styles */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px var(--primary) inset !important;
    -webkit-text-fill-color: white !important;
    transition: background-color 5000s ease-in-out 0s;
}

/* For Firefox */
input:-moz-autofill,
input:-moz-autofill:hover,
input:-moz-autofill:focus,
input:-moz-autofill:active {
    background-color: var(--primary) !important;
    color: white !important;
}

/* For Edge */
input:-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.5) !important;
}
</style>
